import * as React from 'react';
import {forwardRef} from 'react';
import { FormattedMessage } from 'react-intl';

import './style.scss';

import {Icon} from '@atoms/Media/Icon';
import {Tooltip} from '@molecules/TextShowHide/Tooltip';
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';

interface Props {
    index: string;
    isHidden?: boolean;
    devCounter: string;
    itemLabel: string;
    itemFact: string;
    tooltip?: string;
    onClick?: () => void;
}

export const QuickFactsItem = forwardRef<HTMLButtonElement, Props>(({index, isHidden, devCounter, itemLabel, itemFact, tooltip, onClick}, ref) => {
    return (
        <div 
            className="quick-facts__item" 
            key={`quick-facts-${index}`} 
            aria-hidden={isHidden} 
        >
            <dt>
                {process.env.NODE_ENV === 'development' && (devCounter + ' ')}
                {itemLabel}
                {tooltip && !isHidden && <Tooltip rightAlignArrow text={tooltip} />}
                {onClick &&
                    <Button
                        id={`quick-facts-${index}`}
                        icon={<Icon name="info" />}
                        ref={ref}
                        iconBtn
                        onClick={onClick} 
                        tabIndex={isHidden ? -1 : 0}
                        buttonColor={ButtonColor.UNSET} 
                        buttonSize={ButtonSize.DEFAULT} 
                        buttonType={ButtonType.NO_STYLE} 
                    >
                        <FormattedMessage id="jm.components.QuickFacts.readMore" values={{ fact: itemLabel }} />
                    </Button>
                }
            </dt>
            <dd>
                {itemFact}
            </dd>
        </div>
    )
});